
class TokenManager {

    constructor(cookies) {
        this.cookies = cookies;
    }

    setTokenIfNeeded = () => {
        const { cookies } = this
        const queryParams = new URLSearchParams(window.location.search)
        const newToken = queryParams.get('token')

        if (newToken && cookies) {
            cookies.set('token', newToken, {
                path: '/',
                maxAge: 3600 * 9,
                secure: process.env.NODE_ENV === 'production'
            })
        }
    }

    getToken = () => {
        return this.cookies.get('token')
    }
}

export default TokenManager;



// WEBPACK FOOTER //
// ./src/utils/tokenManager.js